
// import React, { useState, useEffect } from "react";
// import MainLayouts from "../../Layout/MainLayouts";
// import { ReactComponent as ChevronRightIcon } from "bootstrap-icons/icons/chevron-right.svg";
// import axios from "axios";
// import ApiServices from "../../api/ApiServices";
// import { toast } from "react-toastify";
// import CreateProductForm from "./productComponet/CreateProductForm";
// import CreateProductStockForm from "./productComponet/CreateProductStockForm";
// import AddImagesForm from "./productComponet/AddImagesForm";
// import { useNavigate } from "react-router-dom";
// import AxiosApiCall from "../../api/AxiosApiCall";

// const AddProductStock = () => {
//     const [step, setStep] = useState(2);
//     const [stockId, setStockId] = useState(null);
//     const [formData, setFormData] = useState({
//         is_serialized: true,
//         name: "",
//         description: "",
//         category_id: "",
//         sub_category_id: "",
//         product_category_id: "",
//         store_id: "",
//         price: "",
//         batch_number: "",
//         stock_id: null,
//         images: [],
//         product_id: "",
//         product_category: null,
//     });


//     const [loading, setLoading] = useState(false);
//     const navigate = useNavigate();

//     // Log formData every time it changes
//     // useEffect(() => {
//     //     console.log("Updated form data:", formData);
//     // }, [formData]);

//     const handleChange = (e) => {
//         const { name, value } = e.target;
//         if (name === "price") {
//             setFormData(prev => ({ ...prev, [name]: value === "" ? "" : parseFloat(value) || "" }));
//         } else if (name === "batch_number") {
//             setFormData(prev => ({ ...prev, [name]: value === "" ? undefined : parseInt(value, 10) }));
//         } else {
//             setFormData(prev => ({ ...prev, [name]: value }));
//         }
//     };

//     // const handleNext = async () => {
//     //     // console.log("Form Data before step submission:", formData);

//     //     // console.log("Form Data before step submission strp:", step);
//     //     try {
//     //         setLoading(true);
//     //         if (step === 1) {
//     //             await handleProductCreation();
//     //         } else if (step === 2) {
//     //             step = step + 1;
//     //             await handleStockCreation();
//     //         } else if (step === 3) {
//     //             await handleImageAddition();
//     //         }
//     //     } catch (error) {
//     //         console.log(error.message);
//     //     } finally {
//     //         // console.log("Loading ended.");
//     //         setLoading(false);
//     //     }
//     // };



//     const handleNext = async () => {
//         // console.log("Form Data before step submission:", formData);

//         // console.log("Form Data before step submission strp:", step);
//         try {
//             setLoading(true);
//             if (step === 2) {
//                 await handleStockCreation();
//             } else if (step === 2) {
//                 step = step + 1;
//                 await handleImageAddition();
//             }
//         } catch (error) {
//             console.log(error.message);
//         } finally {
//             // console.log("Loading ended.");
//             setLoading(false);
//         }
//     };


//     //axios api encryption call
//     const axios = AxiosApiCall();

//     const handleApiCall = async (url, data) => {
//         const authData = JSON.parse(localStorage.getItem("auth"));
//         const token = authData?.token;
//         return await axios.post(url, data, {
//             headers: {
//                 Authorization: `Bearer ${token}`,
//                 "Content-Type": "application/json",
//             },
//         });
//     };

//     // const handleProductCreation = async () => {
//     //     const productData = {
//     //         is_serialized: formData.is_serialized,
//     //         category_id: formData.category_id,
//     //         sub_category_id: formData.sub_category_id,
//     //         product_category_id: formData.product_category_id,
//     //         name: formData.name,
//     //         description: formData.description,
//     //     };
//     //     // console.log("Step 1 - Product Creation Data:", productData);

//     //     // Check if necessary fields are filled
//     //     if (!formData.name || !formData.category_id || !formData.sub_category_id || !formData.product_category_id) {
//     //         toast.error("Please fill in all required fields.");
//     //         return;
//     //     }

//     //     try {
//     //         const response = await handleApiCall(ApiServices.addProducts, productData);
//     //         if (response.status === 200) {
//     //             toast.success(response.data.message);
//     //             setFormData(prev => ({ ...prev, product_id: response.data.product_id }));
//     //             setStep(2);
//     //         } else {
//     //             toast.error(response.data.message);
//     //         }
//     //     } catch (error) {
//     //         toast.error(error.response?.data?.message || 'Failed to create product');
//     //     }
//     // };



//     const [productCategory, setProductCategory] = useState("");

//     const handleStockCreation = async (stock_id, product_category) => {

//         // console.log("handnext", "handle")
//         // console.log("stock_id", stock_id)
//         // console.log("product_category", product_category)

//         //     const stockData = {
//         //         store_id: formData.store_id,
//         //         product_id: formData.product_id,
//         //         price: parseFloat(formData.price),
//         //         description: formData.description,
//         //         batch_number: formData.batch_number || null,
//         //     };

//         //     console.log("Step 2 - Product Stock Creation Data:", stockData);
//         //     try {
//         //         const response = await handleApiCall(ApiServices.createProductStock, stockData);
//         //         if (response.status === 200) {
//         //             toast.success('Product stock created successfully!');
//         //             setFormData(prev => ({
//         //                 ...prev,
//         //                 stock_id: response.data.data.stock_id, // Save stock_id here
//         //                 product_category: response.data.data.product_category,
//         //             }));
//         //             setStep(3);
//         //         } else {
//         //             toast.error(response.data.message);
//         //         }
//         //     } catch (error) {
//         //         toast.error(error.response?.data?.message || 'Failed to create stock product');
//         //     }

//         // Update formData with stock_id and product_category
//         setFormData((prevData) => ({
//             ...prevData,
//             stock_id,
//             product_category,
//         }));
//         setStockId(stock_id);  // Use stock_id 
//         setProductCategory(product_category);
//         // console.log("Received Stock ID from Child:", stock_id);
//         // Move to the next step or handle as needed
//         setStep(3);
//     };
//     // useEffect(() => {
//     //     console.log("Updated stock ID:", stockId); // Log whenever stockId changes
//     // }, [stockId]);

//     const handleImageAddition = async () => {
//         const imageData = {
//             stock_id: formData.stock_id,
//             images: formData.images,
//         };

//         // console.log("Step 3 - Product Image Upload Data:", imageData);

//         try {
//             const response = await handleApiCall(ApiServices.addImages, imageData);
//             if (response.status === 200) {
//                 toast.success('Images added successfully!');
//                 // navigate("/admin/products/stock/list");
//                 navigate("/admin/products/stock/pending");
//             } else {
//                 toast.error(response.data.message);
//             }
//         } catch (error) {
//             toast.error(error.response?.data?.message || 'Failed to add images');
//         }
//     };

//     return (
//         <MainLayouts>
//             <div className="relative overflow-x-auto sm:rounded-lg py-6 w-full">
//                 <section className="w-full pr-[3%] pt-3 my-3" style={{ backgroundColor: "#F7F7F7" }}>
//                     <nav className="bg-gray-200 py-0 px-4 rounded-lg">
//                         <ol className="list-none p-0 inline-flex mb-2">
//                             <li className="flex items-center">
//                                 <p className="text-blue-500 hover:text-blue-600 text-darkGreen3 pr-2">Stock Product </p>
//                                 <ChevronRightIcon />
//                             </li>
//                             <li className="flex items-center">
//                                 <p className="text-orange1">Create</p>
//                             </li>
//                         </ol>
//                     </nav>
//                 </section>

//                 <section className="gray_background">
//                     <div className="container px-1 pb-2 mx-auto">
//                         <div className="lg:w-full md:w-full bg-white rounded-lg py-3 px-2 flex flex-col md:ml-auto w-full mt-10 md:mt-0 relative z-10 shadow-md bg-dGrey3">
//                             {/* {step === 1 && (
//                                 <CreateProductForm
//                                     formData={formData}
//                                     setFormData={setFormData}
//                                     handleChange={handleChange}
//                                     handleNext={handleNext}
//                                     loading={loading}
//                                 />
//                             )} */}
//                             {/* {step === 2 && (
//                                 <CreateProductStockForm
//                                     formData={formData}
//                                     handleChange={handleChange}
//                                     handleNext={handleNext}
//                                     createStock={handleStockCreation}
//                                 />
//                             )} */}
//                             {step === 2 && (
//                                 <CreateProductStockForm
//                                     formData={formData}
//                                     handleNext={handleNext}
//                                     createStock={handleStockCreation} // Only the createStock function is passed
//                                 />
//                             )}

//                             {/* {step === 3 && (
//                                 <AddImagesForm
//                                     formData={formData}
//                                     handleChange={handleChange}
//                                     handleNext={handleNext}
//                                 />
//                             )} */}
//                             {step === 3 && (
//                                 <AddImagesForm
//                                     formData={{
//                                         stock_id: formData.stock_id,
//                                         product_category: formData.product_category,
//                                         name: formData.name,
//                                         images: formData.images || []
//                                     }}
//                                     setFormData={setFormData} // if you need to update images in parent
//                                     handleNext={handleNext}
//                                     loading={loading}
//                                     name={formData.name}                  // pass name
//                                     productCategory={formData.product_category} // pass category
//                                 />
//                             )}
//                         </div>
//                     </div>
//                 </section>
//             </div>
//         </MainLayouts>
//     );
// };

// export default AddProductStock;


import React, { useState, useEffect, useCallback } from "react";
import MainLayouts from "../../Layout/MainLayouts";
import { ReactComponent as ChevronRightIcon } from "bootstrap-icons/icons/chevron-right.svg";
import { ReactComponent as CloudUploadFill } from "bootstrap-icons/icons/cloud-upload-fill.svg";
import { ReactComponent as XSquareFill } from "bootstrap-icons/icons/x-square-fill.svg";
import { ReactComponent as List } from "bootstrap-icons/icons/list.svg";
import ApiServices from "../../api/ApiServices";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import AxiosApiCall from "../../api/AxiosApiCall";
import Spinner from "../spinner/Spinner";

const AddProductStock = () => {
    const [formData, setFormData] = useState({
        store_id: "",
        product_id: "",
        description: "",
        price: "",
        batch_number: "",
        images: [],
    });

    const [stores, setStores] = useState([]);
    const [products, setProducts] = useState([]);
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(true);
    const [submitting, setSubmitting] = useState(false);
    const [defaultStore, setDefaultStore] = useState(1);

    // Product details after stock creation
    const [createdStock, setCreatedStock] = useState(null);

    const navigate = useNavigate();
    const axiosInstance = AxiosApiCall();

    // Fetch stores and products on component mount
    useEffect(() => {
        const fetchInitialData = async () => {
            try {
                const authData = JSON.parse(localStorage.getItem("auth"));
                const token = authData?.token;

                const [storesResponse, productsResponse] = await Promise.all([
                    axiosInstance.get(ApiServices.getAllStore, {
                        headers: { Authorization: `Bearer ${token}` },
                    }),
                    axiosInstance.get(ApiServices.getProducts, {
                        headers: { Authorization: `Bearer ${token}` },
                    }),
                ]);

                // Find store with store_id = 1 as default
                const defaultStore = storesResponse.data.data.find(store => store.store_id === 1);
                const filteredStores = storesResponse.data.data.filter(store => store.store_id !== 1);

                setDefaultStore(defaultStore);
                setStores(filteredStores);
                setProducts(productsResponse.data.data);

                // Set default store if available
                if (defaultStore) {
                    setFormData(prev => ({
                        ...prev,
                        store_id: defaultStore.store_id
                    }));
                }
            } catch (error) {
                // console.error(error);
                toast.error("Error fetching initial data.");
            } finally {
                setLoading(false);
            }
        };

        fetchInitialData();
    }, []);

    // Form validation
    const validateForm = () => {
        const newErrors = {};

        if (!formData.store_id) newErrors.store_id = "Store field is required.";
        if (!formData.description) newErrors.description = "Description field is required.";
        if (!formData.product_id) newErrors.product_id = "Product field is required.";

        if (formData.price === "") {
            newErrors.price = "Price is required.";
        } else if (isNaN(formData.price) || parseFloat(formData.price) <= 0) {
            newErrors.price = "Price must be a positive number.";
        }

        if (formData.batch_number && formData.batch_number < 0) {
            newErrors.batch_number = "Batch number must be a positive number.";
        }

        if (!formData.images.length) {
            newErrors.images = "At least one image is required.";
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    // Handle form field changes
    const handleFieldChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));

        // Clear error for this field
        if (errors[name]) {
            setErrors(prev => ({
                ...prev,
                [name]: ""
            }));
        }
    };

    // Image handling functions
    const convertToBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
        });
    };

    const validateFile = (file) => {
        if (!file.type.startsWith("image/")) {
            toast.info("Only image files are allowed.");
            return false;
        }
        if (file.size > 5 * 1024 * 1024) {
            toast.info("File size exceeds 5MB limit.");
            return false;
        }
        return true;
    };

    const handleFileChange = useCallback(async (e) => {
        const filesArray = Array.from(e.target.files);
        if (filesArray.length + formData.images.length > 6) {
            toast.error("You can only upload a maximum of 6 images.");
            return;
        }

        const base64Images = [];
        for (const file of filesArray) {
            if (!validateFile(file)) continue;
            try {
                const base64 = await convertToBase64(file);
                base64Images.push(base64);
            } catch {
                toast.error("Failed to convert image.");
            }
        }

        setFormData(prev => ({
            ...prev,
            images: [...prev.images, ...base64Images]
        }));

        // Clear images error if images are added
        if (errors.images) {
            setErrors(prev => ({ ...prev, images: "" }));
        }
    }, [formData.images, errors.images]);

    const handleImageRemove = (index) => {
        setFormData(prev => ({
            ...prev,
            images: prev.images.filter((_, i) => i !== index)
        }));
    };

    const renderImagePreviews = () => {
        return formData.images.map((image, index) => (
            <div key={index} className="relative w-20 h-20">
                <img src={image} alt={`Preview ${index}`} className="w-full h-full object-cover rounded" />
                <button
                    type="button"
                    onClick={() => handleImageRemove(index)}
                    className="absolute top-0 right-0 bg-red-500 text-white rounded-full p-1 hover:bg-red-600"
                    title="Remove image"
                >
                    <XSquareFill className="w-5 h-5 text-red1" />
                </button>
            </div>
        ));
    };

    // Get selected product name for display
    const getSelectedProductName = () => {
        const selectedProduct = products.find(p => p.product_id == formData.product_id);
        return selectedProduct ? selectedProduct.name : "";
    };

    // Combined submit handler
    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validateForm()) {
            toast.error("Please fill all field before submitting.");
            return;
        }

        setSubmitting(true);

        try {
            const authData = JSON.parse(localStorage.getItem("auth"));
            const token = authData?.token;

            // Step 1: Create product stock
            const stockData = {
                store_id: formData.store_id,
                product_id: formData.product_id,
                description: formData.description,
                price: parseFloat(formData.price),
                batch_number: formData.batch_number || null,
            };
            // console.log("stock data", stockData);
            const stockResponse = await axiosInstance.post(ApiServices.createProductStock, stockData, {
                headers: { Authorization: `Bearer ${token}` },
            });

            if (stockResponse.data.status !== 200) {
                toast.error(stockResponse.data.message || "Failed to create product stock.");
                return;
            }

            const { stock_id, product_category, name } = stockResponse.data.data;
            setCreatedStock({ stock_id, product_category, name });

            // Step 2: Upload images
            const imageData = {
                stock_id: stock_id,
                images: formData.images.map(image => image.split(",")[1]), // Remove base64 prefix
            };
            // console.log("stock data", imageData);
            const imageResponse = await axiosInstance.post(ApiServices.addImagesToProductStock, imageData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            });

            if (imageResponse.data.status === 200) {
                toast.success("Product stock created and images uploaded successfully!");
                navigate("/admin/products/stock/pending");
            } else {
                toast.error(imageResponse.data.message || "Failed to upload images.");
            }

        } catch (error) {
            // console.error("Error in form submission:", error);
            toast.error(error.response?.data?.message || "An error occurred while processing your request.");
        } finally {
            setSubmitting(false);
        }
    };

    // if (loading) {
    //     return (
    //         <MainLayouts>
    //             <Spinner loading={loading} />
    //         </MainLayouts>
    //     );
    // }

    return (
        <MainLayouts>
            <div className="relative overflow-x-auto sm:rounded-lg py-6 w-full">
                <section className="w-full pr-[3%] pt-3 my-3" style={{ backgroundColor: "#F7F7F7" }}>
                    <nav className="bg-gray-200 py-0 px-4 rounded-lg">
                        <ol className="list-none p-0 inline-flex mb-2">
                            <li className="flex items-center">
                                <p className="text-blue-500 hover:text-blue-600 text-darkGreen3 pr-2">Stock Product</p>
                                <ChevronRightIcon />
                            </li>
                            <li className="flex items-center">
                                <p className="text-orange1">Create</p>
                            </li>
                        </ol>
                    </nav>
                </section>

                <section className="gray_background">
                    <div className="container px-1 pb-2 mx-auto">
                        <div className="lg:w-full md:w-full bg-white rounded-lg py-3 px-2 flex flex-col md:ml-auto w-full mt-10 md:mt-0 relative z-10 shadow-md bg-dGrey3">
                            <form onSubmit={handleSubmit}>
                                <h2 className="text-orange1 mb-6">Create Product Stock</h2>

                                {/* Stock Creation Fields */}
                                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-6">
                                    {/* Store Field */}
                                    <div className="w-full">
                                        <label htmlFor="store_id" className="block mb-2 text-sm font-medium text-gray-900">
                                            Store
                                        </label>
                                        {/* {defaultStore ? ( */}
                                        <div>
                                            <input
                                                type="text"
                                                readOnly
                                                value="Joatech Store"
                                                className="bg-gray-100 border border-dGrey1 text-gray-900 text-sm rounded-lg block w-full p-2.5 cursor-not-allowed"
                                            />
                                            <input type="hidden" name="store_id" value={defaultStore.store_id} />
                                        </div>
                                        {/* ) : (
                                            <select
                                                id="store_id"
                                                name="store_id"
                                                value={formData.store_id}
                                                onChange={handleFieldChange}
                                                className="bg-gray-50 border border-dGrey1 text-gray-900 text-sm rounded-lg block w-full p-2.5"
                                            >
                                                <option value="" disabled>Select Store</option>
                                                {stores.map(store => (
                                                    <option key={store.store_id} value={store.store_id}>
                                                        {store.name}
                                                    </option>
                                                ))}
                                            </select>
                                        )} */}
                                        {/* {errors.store_id && <p className="text-red1 text-sm mt-1">{errors.store_id}</p>} */}
                                    </div>

                                    {/* Product Field */}
                                    <div className="w-full">
                                        <label htmlFor="product_id" className="block mb-2 text-sm font-medium text-gray-900">
                                            Product
                                        </label>
                                        <select
                                            id="product_id"
                                            name="product_id"
                                            value={formData.product_id}
                                            onChange={handleFieldChange}
                                            className="bg-gray-50 border border-dGrey1 text-gray-900 text-sm rounded-lg block w-full p-2.5"
                                        >
                                            <option value="" disabled>Select Product</option>
                                            {products.length === 0 ? (
                                                <option value="" disabled>No products available</option>
                                            ) : (
                                                products.map(product => (
                                                    <option key={product.product_id} value={product.product_id}>
                                                        {product.name}
                                                    </option>
                                                ))
                                            )}
                                        </select>
                                        {errors.product_id && <p className="text-red1 text-sm mt-1">{errors.product_id}</p>}
                                    </div>

                                    {/* Price Field */}
                                    <div className="w-full">
                                        <label htmlFor="price" className="block mb-2 text-sm font-medium text-gray-900">
                                            Price
                                        </label>
                                        <input
                                            type="text"
                                            id="price"
                                            name="price"
                                            value={formData.price}
                                            onChange={handleFieldChange}
                                            className="bg-gray-50 border border-dGrey1 text-gray-900 text-sm rounded-lg block w-full p-2.5"
                                            placeholder="Enter price"
                                        />
                                        {errors.price && <p className="text-red1 text-sm mt-1">{errors.price}</p>}
                                    </div>

                                    {/* Batch Number Field */}
                                    <div className="w-full">
                                        <label htmlFor="batch_number" className="block mb-2 text-sm font-medium text-gray-900">
                                            Batch Number
                                        </label>
                                        <input
                                            type="number"
                                            id="batch_number"
                                            name="batch_number"
                                            value={formData.batch_number || ""}
                                            onChange={handleFieldChange}
                                            className="bg-gray-50 border border-dGrey1 text-gray-900 text-sm rounded-lg block w-full p-2.5"
                                            placeholder="Enter batch number"
                                        />
                                        {errors.batch_number && <p className="text-red1 text-sm mt-1">{errors.batch_number}</p>}
                                    </div>
                                </div>

                                {/* Description Field */}
                                <div className="w-full mb-6">
                                    <label htmlFor="description" className="block mb-2 text-sm font-medium text-gray-900">
                                        Brief Description
                                    </label>
                                    <textarea
                                        name="description"
                                        id="description"
                                        value={formData.description}
                                        onChange={handleFieldChange}
                                        rows={4}
                                        className="bg-gray-50 border border-dGrey1 text-gray-900 text-sm rounded-lg block w-full p-2.5"
                                        placeholder="Enter brief description here"
                                    />
                                    {errors.description && <p className="text-red1 text-sm mt-1">{errors.description}</p>}
                                </div>

                                {/* Product Info Display (if product selected) */}
                                {formData.product_id && (
                                    <div className="flex flex-col md:flex-row gap-6 mb-6 p-4 bg-gray-50 rounded-lg">
                                        <div className="flex-1">
                                            <label className="block mb-2 text-sm font-medium text-gray-900">
                                                Selected Product
                                            </label>
                                            <div className="bg-white border border-dGrey1 text-gray-900 text-sm rounded-lg block w-full p-2.5">
                                                {getSelectedProductName()}
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {/* Image Upload Section */}
                                <div className="mb-6">
                                    <h3 className="text-lg font-medium text-gray-900 mb-4">Product Images</h3>

                                    {/* Image Previews */}
                                    {formData.images.length > 0 && (
                                        <div className="flex flex-wrap gap-2 mb-4">
                                            {renderImagePreviews()}
                                        </div>
                                    )}

                                    {/* Image Upload Area */}
                                    <div className="flex items-center justify-center w-full">
                                        <label
                                            htmlFor="images"
                                            className="flex flex-col items-center justify-center w-full h-30 border-2 border-orange1 border-dashed rounded-lg cursor-pointer bg-gray-50 hover:bg-gray-100"
                                        >
                                            <div className="flex flex-col items-center justify-center pt-5 pb-6">
                                                <CloudUploadFill className="w-8 h-8 mb-4 text-orange1" />
                                                <p className="mb-2 text-sm text-gray-500">
                                                    <span className="font-semibold">Click to upload</span> or drag and drop
                                                </p>
                                                <p className="text-xs text-gray-500">PNG, JPG, GIF up to 5MB (Max 6 images)</p>
                                            </div>
                                            <input
                                                id="images"
                                                type="file"
                                                accept="image/*"
                                                multiple
                                                onChange={handleFileChange}
                                                className="hidden"
                                            />
                                        </label>
                                    </div>
                                    {errors.images && <p className="text-red1 text-sm mt-1">{errors.images}</p>}
                                </div>

                                {/* Action Buttons */}
                                <div className="flex flex-col gap-4 md:flex-row md:gap-4 md:justify-end">
                                    <button
                                        type="button"
                                        onClick={() => navigate("/admin/products/stock/list")}
                                        className="text-lGrey bg-black2 hover:bg-black2 font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center"
                                    >
                                        <List className="mr-2" />
                                        Go Back
                                    </button>

                                    <button
                                        type="submit"
                                        disabled={submitting}
                                        className={`text-lGrey font-medium rounded-lg text-sm px-5 py-2.5 text-center ${submitting
                                            ? "bg-darkGreen3 cursor-not-allowed"
                                            : "bg-darkGreen3 hover:bg-darkGreen2"
                                            }`}
                                    >
                                        {submitting ? "Processing..." : "Create Product Stock"}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </section>
            </div>
        </MainLayouts>
    );
};

export default AddProductStock;